<template>
  <div class="landing-page">
    <div class="landing-background">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>


    <div class="landing-content">
      <!-- Left Side: Hero and Features -->
      <div class="landing-hero">
        <div class="brand">
          <div class="logo-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <span>Avto Test Pro</span>
        </div>

        <h1 class="hero-title">Haydovchilik guvohnomasini olish uchun imtihonlarga online <span>Tayyorlaning</span>
        </h1>
        <p class="hero-subtitle">
          Yo'l harakatiga doir 1220+ savollar yordamida imtihonlarga online tayyorlaning!
        </p>

        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon bg-blue">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <div class="feature-text">
              <h4>Testlar to'plami</h4>
              <p>Yo'l harakati qoidalariga doir testlar to'plami.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon bg-purple">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="10" rx="2"></rect>
                <circle cx="12" cy="5" r="2"></circle>
                <path d="M12 7v4"></path>
                <line x1="8" y1="16" x2="8" y2="16"></line>
                <line x1="16" y1="16" x2="16" y2="16"></line>
              </svg>
            </div>
            <div class="feature-text">
              <h4>AI Belgi Aniqlash</h4>
              <p>Kamera orqali yo'l belgilarini sun'iy intellekt yordamida aniqlash.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon bg-green">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="6" width="20" height="14" rx="2"></rect>
                <path d="M12 10v6"></path>
                <path d="M9 13h6"></path>
                <path d="M6 6V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2"></path>
              </svg>
            </div>
            <div class="feature-text">
              <h4>Tibbiy Yordam</h4>
              <p>Birinchi tibbiy yordam ko'rsatish qoidalari va yo'riqnomalar.</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon bg-red">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <div class="feature-text">
              <h4>Jarimalar</h4>
              <p>Yo'l harakati qoidalari buzilishiga doir barcha jarimalar ma'lumoti.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Side: Login Form -->
      <div class="login-wrapper">
        <div class="login-card">
          <div class="card-header">
            <h2>Tizimga kirish</h2>
            <p>Barcha imkoniyatlardan foydalanish uchun hisobingizga kiring.</p>
          </div>

          <!-- Xatolik -->
          <div v-if="error" class="error-message">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            {{ error }}
          </div>

          <!-- Login form -->
          <form @submit.prevent="handleSubmit" class="login-form">
            <div class="input-group">
              <label>{{ $t('login.phone') }}</label>
              <div class="phone-input">
                <span class="country-code">+998</span>
                <input type="tel" v-model="phoneNumber" :placeholder="$t('login.phonePlaceholder')" @input="formatPhone"
                  :class="{ 'has-error': phoneError }" />
              </div>
              <span v-if="phoneError" class="input-error">{{ phoneError }}</span>
              <span v-if="detectedOperator" class="operator-badge">{{ detectedOperator }}</span>
            </div>

            <div class="input-group">
              <label>{{ $t('login.password') }}</label>
              <div class="password-input">
                <input :type="showPassword ? 'text' : 'password'" v-model="password"
                  :placeholder="$t('login.passwordPlaceholder')" @keyup.enter="handleSubmit" />
                <button type="button" class="toggle-password" @click="showPassword = !showPassword">
                  <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2">
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="form-footer">
              <label class="remember-me">
                <input type="checkbox" v-model="rememberMe" />
                <span>{{ $t('login.rememberMe') }}</span>
              </label>
              <button type="button" class="forgot-link" @click="handleForgotPassword">
                {{ $t('login.forgotPassword') }}
              </button>
            </div>

            <button type="submit" class="login-button" :disabled="loading">
              <span v-if="loading" class="spinner"></span>
              <span v-else>{{ $t('login.loginBtn') }}</span>
            </button>

            <div class="divider">
              <span>{{ $t('login.or') }}</span>
            </div>

            <button type="button" class="telegram-button" @click="handleTelegramRegister">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.02-.14-.05-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.36.5-.45-.01-1.31-.25-1.95-.46-.84-.28-1.51-.43-1.45-.91.03-.25.38-.51 1.07-.78 4.2-1.83 7-3.03 8.4-3.61 4-1.66 4.83-1.95 5.37-1.96.12 0 .38.03.55.18.14.12.18.28.2.44-.01.13-.03.27-.05.41z" />
              </svg>
              Telegram orqali
            </button>

            <p class="register-prompt">
              {{ $t('login.noAccount') }}
              <button type="button" class="register-link" @click="handleTelegramRegister">
                Ro'yxatdan o'tish
              </button>
            </p>
          </form>
        </div>
      </div>
    </div>

    <!-- Telegram modal - @smartypx_bot uchun -->
    <div v-if="telegramModalVisible" class="modal-overlay" @click="telegramModalVisible = false">
      <div class="modal-content" @click.stop>
        <button class="modal-close" @click="telegramModalVisible = false">×</button>

        <div class="modal-header">
          <div class="telegram-logo">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.02-.14-.05-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.36.5-.45-.01-1.31-.25-1.95-.46-.84-.28-1.51-.43-1.45-.91.03-.25.38-.51 1.07-.78 4.2-1.83 7-3.03 8.4-3.61 4-1.66 4.83-1.95 5.37-1.96.12 0 .38.03.55.18.14.12.18.28.2.44-.01.13-.03.27-.05.41z" />
            </svg>
          </div>
          <h3>{{ telegramModalTitle }}</h3>
          <p>{{ telegramModalMessage }}</p>
        </div>

        <!-- QR kod va bot linki -->
        <div class="qr-code">
          <img :src="qrCodeUrl" alt="QR Code" />
        </div>

        <div class="steps">
          <div class="step">
            <span class="step-number">1</span>
            <span>{{ $t('login.step1') }}</span>
          </div>
          <div class="step">
            <span class="step-number">2</span>
            <span>{{ $t('login.step2') }}</span>
          </div>
          <div class="step">
            <span class="step-number">3</span>
            <span>{{ $t('login.step3') }}</span>
          </div>
          <div class="step" v-if="telegramAction === 'reset'">
            <span class="step-number">4</span>
            <span>{{ $t('login.step4Reset') }}</span>
          </div>
          <div class="step" v-else-if="telegramAction === 'register'">
            <span class="step-number">4</span>
            <span>{{ $t('login.step4Register') }}</span>
          </div>
        </div>

        <a :href="telegramBotLink" target="_blank" class="telegram-open-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.02-.14-.05-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.36.5-.45-.01-1.31-.25-1.95-.46-.84-.28-1.51-.43-1.45-.91.03-.25.38-.51 1.07-.78 4.2-1.83 7-3.03 8.4-3.61 4-1.66 4.83-1.95 5.37-1.96.12 0 .38.03.55.18.14.12.18.28.2.44-.01.13-.03.27-.05.41z" />
          </svg>
          Telegram'ni ochish
        </a>

        <div class="bot-note">
          <span>🤖 Bot: @smartypx_bot</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      phoneNumber: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      loading: false,
      error: '',
      requiresPremium: false,
      phoneError: '',
      telegramModalVisible: false,
      telegramAction: 'login', // 'register', 'reset', 'login'
      telegramBotUsername: 'smartypx_bot'
    }
  },
  computed: {
    fullPhone() {
      if (!this.phoneNumber) return ''
      const clean = this.phoneNumber.replace(/\D/g, '')
      if (clean.length === 0) return ''
      return `+998${clean}`
    },
    detectedOperator() {
      const clean = this.phoneNumber.replace(/\D/g, '')
      if (clean.length < 2) return ''

      const code = clean.substring(0, 2)
      const operators = {
        '90': 'Beeline', '91': 'Beeline',
        '93': 'Ucell', '94': 'Ucell',
        '95': 'Uzmobile', '99': 'Uzmobile',
        '97': 'MobiUz', '88': 'MobiUz',
        '87': 'Mobiuz',
        '98': 'Perfectum', '33': 'Humans'
      }
      return operators[code] || ''
    },
    telegramModalTitle() {
      if (this.telegramAction === 'register') {
        return this.$t('login.telegramRegister')
      } else if (this.telegramAction === 'reset') {
        return this.$t('login.telegramReset')
      }
      return this.$t('login.telegramLogin')
    },
    telegramModalMessage() {
      if (this.telegramAction === 'register') {
        return this.$t('login.telegramRegisterMsg')
      } else if (this.telegramAction === 'reset') {
        return this.$t('login.telegramResetMsg')
      }
      return this.$t('login.telegramLoginMsg')
    },
    telegramBotLink() {
      return `https://t.me/${this.telegramBotUsername}`
    },
    qrCodeUrl() {
      // QR kodda faqat bot linki ko'rsatiladi, start parametri ishlatilmaydi
      // chunki bot start bosganda menyu ko'rsatadi
      return `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(this.telegramBotLink)}`
    }
  },
  methods: {
    formatPhone(e) {
      let value = e.target.value.replace(/\D/g, '')
      if (value.length > 9) value = value.slice(0, 9)

      let formatted = ''
      if (value.length > 0) {
        formatted += value.slice(0, 2)
        if (value.length > 2) {
          formatted += ' ' + value.slice(2, 5)
        }
        if (value.length > 5) {
          formatted += ' ' + value.slice(5, 7)
        }
        if (value.length > 7) {
          formatted += ' ' + value.slice(7, 9)
        }
      }
      this.phoneNumber = formatted
      this.validatePhone()
    },
    validatePhone() {
      const clean = this.phoneNumber.replace(/\D/g, '')
      if (clean.length === 0) {
        this.phoneError = ''
        return true
      }
      if (clean.length !== 9) {
        this.phoneError = this.$t('login.phoneError9')
        return false
      }
      // Operator tekshiruvi o'chirib tashlandi (faqat 9 xonali son ekanligi tekshiriladi)
      this.phoneError = ''
      return true
    },
    async handleSubmit() {
      if (!this.validatePhone()) return
      if (!this.password) {
        this.error = this.$t('login.passwordRequired')
        return
      }

      this.loading = true
      this.error = ''

      try {
        await this.$store.dispatch('auth/login', {
          phone: this.fullPhone,
          password: this.password
        })

        this.$message.success(this.$t('login.loginSuccess'))
        const redirect = this.$route.query.redirect || '/'
        this.$router.push(redirect)
      } catch (err) {
        this.error = err?.detail || this.$t('login.loginError')
      } finally {
        this.loading = false
      }
    },
    // Ro'yxatdan o'tish - Telegram botga yo'naltirish
    handleTelegramRegister() {
      this.telegramAction = 'register'
      this.telegramModalVisible = true
    },
    // Parolni tiklash - Telegram botga yo'naltirish
    handleForgotPassword() {
      this.telegramAction = 'reset'
      this.telegramModalVisible = true
    }
  }
}
</script>

<style scoped>
.landing-page {
  min-height: 100vh;
  position: relative;
  background: var(--bg-color, #f8fafc);
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-overflow-scrolling: touch;
}

[data-theme="dark"] .landing-page,
.dark .landing-page {
  background: #0f172a;
}

/* Background Shapes */
.landing-background {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.shape {
  position: absolute;
  filter: blur(80px);
  opacity: 0.5;
  border-radius: 50%;
  animation: floatBG 15s infinite alternate ease-in-out;
}

.shape-1 {
  top: -10%;
  left: -10%;
  width: 500px;
  height: 500px;
  background: rgba(99, 102, 241, 0.3);
}

.shape-2 {
  bottom: -10%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: rgba(168, 85, 247, 0.3);
  animation-delay: -5s;
}

.shape-3 {
  top: 40%;
  left: 40%;
  width: 400px;
  height: 400px;
  background: rgba(56, 189, 248, 0.2);
  animation-delay: -10s;
}

@keyframes floatBG {
  0% {
    transform: translate(0, 0) scale(1);
  }

  100% {
    transform: translate(50px, 50px) scale(1.1);
  }
}

/* Layout Content */
.landing-content {
  position: relative;
  z-index: 10;
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 20px;
  display: grid;
  grid-template-columns: 1fr 450px;
  gap: 60px;
  align-items: center;
}

/* Hero Section */
.landing-hero {
  padding-right: 20px;
  animation: slideRight 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideRight {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: rgba(99, 102, 241, 0.1);
  padding: 10px 20px;
  border-radius: 40px;
  margin-bottom: 30px;
  border: 1px solid rgba(99, 102, 241, 0.2);
}

.logo-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.logo-icon svg {
  width: 20px;
  height: 20px;
}

.brand span {
  font-weight: 800;
  font-size: 18px;
  color: #4f46e5;
}

[data-theme="dark"] .brand span,
.dark .brand span {
  color: #818cf8;
}

.hero-title {
  font-size: 46px;
  font-weight: 900;
  line-height: 1.1;
  color: var(--text-color, #0f172a);
  margin-bottom: 24px;
}

.hero-title span {
  background: linear-gradient(135deg, #4f46e5, #9333ea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

[data-theme="dark"] .hero-title,
.dark .hero-title {
  color: #f8fafc;
}

[data-theme="dark"] .hero-title span,
.dark .hero-title span {
  background: linear-gradient(135deg, #818cf8, #c084fc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-subtitle {
  font-size: 20px;
  color: var(--text-soft, #475569);
  margin-bottom: 40px;
  line-height: 1.6;
  max-width: 600px;
}

[data-theme="dark"] .hero-subtitle,
.dark .hero-subtitle {
  color: #94a3b8;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: var(--card-bg, rgba(255, 255, 255, 0.7));
  padding: 20px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.5));
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

[data-theme="dark"] .feature-item,
.dark .feature-item {
  background: rgba(30, 41, 59, 0.6);
  border-color: rgba(255, 255, 255, 0.05);
}

.feature-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.bg-blue {
  background: rgba(59, 130, 246, 0.1);
}

.bg-purple {
  background: rgba(168, 85, 247, 0.1);
}

.bg-green {
  background: rgba(16, 185, 129, 0.1);
}

.bg-red {
  background: rgba(239, 68, 68, 0.1);
}

.feature-text h4 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-color, #1e293b);
}

.feature-text p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-soft, #64748b);
}

[data-theme="dark"] .feature-text h4,
.dark .feature-text h4 {
  color: #f8fafc;
}

[data-theme="dark"] .feature-text p,
.dark .feature-text p {
  color: #94a3b8;
}

/* Login Container */
.login-wrapper {
  animation: slideLeft 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  width: 100%;
}

@keyframes slideLeft {
  from {
    opacity: 0;
    transform: translateX(40px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.login-card {
  background: var(--card-bg, #ffffff);
  border-radius: 28px;
  padding: 40px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.8));
  backdrop-filter: blur(20px);
}

[data-theme="dark"] .login-card,
.dark .login-card {
  background: rgba(30, 41, 59, 0.8);
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.card-header {
  text-align: center;
  margin-bottom: 32px;
}

.card-header h2 {
  font-size: 28px;
  font-weight: 800;
  color: var(--text-color, #0f172a);
  margin: 0 0 8px 0;
}

.card-header p {
  font-size: 15px;
  color: var(--text-soft, #64748b);
  margin: 0;
}

[data-theme="dark"] .card-header h2,
.dark .card-header h2 {
  color: #f8fafc;
}

[data-theme="dark"] .card-header p,
.dark .card-header p {
  color: #94a3b8;
}

/* Existing Error Message */
.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  color: #dc2626;
  font-size: 14px;
  margin-bottom: 24px;
}

/* Form Styles */
.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color, #1e293b);
  margin-bottom: 8px;
}

[data-theme="dark"] .input-group label,
.dark .input-group label {
  color: #e2e8f0;
}

.phone-input,
.password-input {
  display: flex;
  align-items: center;
  border: 1.5px solid var(--border-color, #e2e8f0);
  border-radius: 16px;
  background: var(--bg-color, #f8fafc);
  transition: all 0.2s;
  overflow: hidden;
}

[data-theme="dark"] .phone-input,
.dark .phone-input,
[data-theme="dark"] .password-input,
.dark .password-input {
  background: rgba(15, 23, 42, 0.5);
  border-color: #334155;
}

.phone-input:focus-within,
.password-input:focus-within {
  border-color: #6366f1;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.country-code {
  padding: 14px 0 14px 16px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color, #1e293b);
  background: transparent;
}

[data-theme="dark"] .country-code,
.dark .country-code {
  color: #f8fafc;
}

.phone-input input,
.password-input input {
  flex: 1;
  padding: 14px 16px;
  border: none;
  background: transparent;
  font-size: 16px;
  outline: none;
  color: var(--text-color, #1e293b);
  font-weight: 500;
}

[data-theme="dark"] .phone-input input,
.dark .phone-input input,
[data-theme="dark"] .password-input input,
.dark .password-input input {
  color: #f8fafc;
}

.phone-input input::placeholder,
.password-input input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.toggle-password {
  padding: 0 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.toggle-password:hover {
  color: #6366f1;
}

.input-error {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: #dc2626;
}

.operator-badge {
  display: inline-block;
  margin-top: 6px;
  padding: 3px 10px;
  background: #d1fae5;
  color: #059669;
  font-size: 12px;
  font-weight: 700;
  border-radius: 20px;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.remember-me input {
  width: 18px;
  height: 18px;
  accent-color: #6366f1;
  cursor: pointer;
}

.remember-me span {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-soft, #64748b);
}

[data-theme="dark"] .remember-me span,
.dark .remember-me span {
  color: #94a3b8;
}

.forgot-link {
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: #6366f1;
  cursor: pointer;
  transition: color 0.2s;
}

.forgot-link:hover {
  color: #4f46e5;
  text-decoration: underline;
}

.login-button {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border: none;
  border-radius: 16px;
  color: white;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.25);
}

.login-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(99, 102, 241, 0.4);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.divider {
  position: relative;
  text-align: center;
  margin: 28px 0;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border-color, #e2e8f0);
}

[data-theme="dark"] .divider::before,
.dark .divider::before {
  background: #334155;
}

.divider span {
  position: relative;
  background: var(--card-bg, #ffffff);
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-soft, #94a3b8);
}

[data-theme="dark"] .divider span,
.dark .divider span {
  background: #1e293b;
  color: #64748b;
}

.telegram-button {
  width: 100%;
  padding: 14px;
  background: #0088cc;
  border: none;
  border-radius: 16px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 0.2s;
  box-shadow: 0 4px 12px rgba(0, 136, 204, 0.2);
}

.telegram-button:hover {
  background: #0077b3;
  transform: translateY(-2px);
}

.register-prompt {
  text-align: center;
  margin-top: 24px;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-soft, #64748b);
}

[data-theme="dark"] .register-prompt,
.dark .register-prompt {
  color: #94a3b8;
}

.register-link {
  background: none;
  border: none;
  color: #6366f1;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  margin-left: 6px;
}

.register-link:hover {
  color: #4f46e5;
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .landing-content {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 60px 20px;
  }

  .landing-hero {
    text-align: center;
    padding-right: 0;
  }

  .hero-subtitle {
    margin: 0 auto 40px;
  }

  .features-grid {
    text-align: left;
  }

  .login-wrapper {
    max-width: 500px;
    margin: 0 auto;
  }
}

@media (max-width: 640px) {
  .landing-page {
    display: block;
    min-height: 100vh;
    height: auto;
    padding: 20px 0;
  }

  .landing-content {
    display: flex;
    flex-direction: column;
    padding: 20px 16px 40px;
    gap: 30px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
    margin-bottom: 24px;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .feature-item {
    padding: 14px;
  }

  .login-card {
    padding: 28px 20px;
    border-radius: 20px;
  }

  .card-header h2 {
    font-size: 22px;
  }

  .brand {
    margin-bottom: 20px;
  }
}

/* Modal and QR styles from original */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.modal-content {
  background: var(--card-bg, white);
  border-radius: 28px;
  padding: 40px;
  max-width: 440px;
  width: 90%;
  position: relative;
  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

[data-theme="dark"] .modal-content,
.dark .modal-content {
  background: #1e293b;
  color: #f8fafc;
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--bg-color, #f1f5f9);
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-soft, #64748b);
  transition: all 0.2s;
}

.modal-close:hover {
  background: #e2e8f0;
  transform: rotate(90deg);
  color: #0f172a;
}

[data-theme="dark"] .modal-close,
.dark .modal-close {
  background: #0f172a;
  color: #94a3b8;
}

.modal-header {
  text-align: center;
  margin-bottom: 30px;
}

.telegram-logo {
  width: 64px;
  height: 64px;
  background: #0088cc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 8px 24px rgba(0, 136, 204, 0.3);
}

.telegram-logo svg {
  color: white;
  width: 32px;
  height: 32px;
}

.modal-header h3 {
  font-size: 24px;
  font-weight: 800;
  margin: 0 0 10px 0;
  color: var(--text-color, #0f172a);
}

[data-theme="dark"] .modal-header h3,
.dark .modal-header h3 {
  color: #f8fafc;
}

.modal-header p {
  font-size: 15px;
  color: var(--text-soft, #64748b);
  margin: 0;
  line-height: 1.5;
}

[data-theme="dark"] .modal-header p,
.dark .modal-header p {
  color: #94a3b8;
}

.qr-code {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  padding: 20px;
  background: white;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.qr-code img {
  width: 180px;
  height: 180px;
}

.steps {
  margin: 30px 0;
}

.step {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
}

.step:not(:last-child) {
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

[data-theme="dark"] .step:not(:last-child),
.dark .step:not(:last-child) {
  border-color: #334155;
}

.step-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.3);
}

.step span:last-child {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-color, #1e293b);
}

[data-theme="dark"] .step span:last-child,
.dark .step span:last-child {
  color: #e2e8f0;
}

.telegram-open-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px;
  background: #0088cc;
  border-radius: 16px;
  color: white;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  transition: all 0.3s;
  box-shadow: 0 8px 20px rgba(0, 136, 204, 0.25);
}

.telegram-open-btn:hover {
  background: #0077b3;
  transform: translateY(-2px);
}

.bot-note {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
}
</style>
